import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { resetPassword } from '../auth/authApi';
import Layout from '../components/Layout';
import Spinner from '../components/Spinner';

const inputStyle = {
  width: '100%', padding: '12px', borderRadius: '6px',
  border: '1px solid rgba(255, 255, 255, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.1)',
  color: '#fff', fontSize: '1em', outline: 'none',
};
const labelStyle = { display: 'block', marginBottom: '8px', color: '#fff', fontWeight: '500' };

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!password || password.length < 8) {
      setError('Please choose a password of at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords don’t match.');
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      if (err.message === 'invalid_or_expired_token') {
        setError('This reset link is invalid or has expired. Request a new one.');
      } else {
        setError('Could not reset your password. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: '40px' }}>
          <h2 className="major" style={{ textAlign: 'center' }}>Set a new password</h2>

          <div className="content" style={{
            maxWidth: '600px', margin: '20px auto 40px', padding: '30px',
            backgroundColor: 'rgba(27, 31, 34, 0.85)', borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}>
            {!token ? (
              <div style={{ textAlign: 'center', color: '#fff' }}>
                <p style={{ lineHeight: 1.6 }}>This reset link is missing its token. Please use the
                  link from your email, or <Link to="/forgot-password" style={{ color: '#FF5722', textDecoration: 'none' }}>request a new one</Link>.</p>
              </div>
            ) : done ? (
              <div style={{ textAlign: 'center', color: '#fff' }}>
                <p style={{ fontSize: '1.05em', color: '#8bc34a' }}>✓ Your password has been reset.</p>
                <p style={{ marginTop: '10px', opacity: 0.85 }}>Redirecting you to login…</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '20px' }}>
                  <label htmlFor="password" style={labelStyle}>New password</label>
                  <input id="password" type="password" value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="At least 8 characters" style={inputStyle} />
                </div>
                <div style={{ marginBottom: '20px' }}>
                  <label htmlFor="confirm" style={labelStyle}>Confirm new password</label>
                  <input id="confirm" type="password" value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    placeholder="Re-enter your password" style={inputStyle} />
                </div>
                {error && (
                  <div style={{
                    padding: '10px', marginBottom: '15px',
                    backgroundColor: 'rgba(255, 87, 34, 0.2)', border: '1px solid #FF5722',
                    borderRadius: '6px', color: '#FF5722', fontSize: '0.9em',
                  }}>{error}</div>
                )}
                <button type="submit" disabled={loading} style={{
                  width: '100%', padding: '15px', borderRadius: '6px', border: 'none',
                  backgroundColor: loading ? '#999' : '#FF5722', color: '#fff',
                  fontSize: '1.1em', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
                }}>
                  {loading ? (<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}><Spinner size={16} />Saving…</span>) : 'Reset password'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ResetPassword;
